import type { IMarket } from "~/types/event";

export const getMarketGroupId = (market: IMarket): string =>
  market.marketGroupKey || market.id;

export const buildMarketGroups = (
  markets: IMarket[]
): Map<string, IMarket[]> => {
  const groups = new Map<string, IMarket[]>();

  for (const market of markets) {
    const groupId = getMarketGroupId(market);
    const group = groups.get(groupId);

    if (group) {
      group.push(market);
      continue;
    }

    groups.set(groupId, [market]);
  }

  return groups;
};
